import Box from '@amzn/meridian/box';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import Icon from '@amzn/meridian/icon';
import Link from '@amzn/meridian/link';
import Responsive from '@amzn/meridian/responsive';
import Row from '@amzn/meridian/row';
import Sheet from '@amzn/meridian/sheet';
import Text from '@amzn/meridian/text';
import { colorGray100 } from '@amzn/meridian-tokens/base/color';
import closeSmallTokens from '@amzn/meridian-tokens/base/icon/close-small';
import documentTokens from '@amzn/meridian-tokens/base/icon/document';
import supportChatTokens from '@amzn/meridian-tokens/base/icon/support-chat';
import {
  MixPanel,
  MixPanelEventName,
  ScreenSize,
} from '@amzn/rangoli-seller-desktop-utils/src/index';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { redirectionUrls } from '../../constants/apiConstants';
import { helpAndSupportStore } from '../../store/HelpAndSupportStore';
import { iconBlueColorStyle } from '../../Style/Style';
import uiTextForHelpMenu from '../../utils/helpAndSupport.json';

const { helpAndSupport } = uiTextForHelpMenu;
const { title, FAQTitle, HowToGuideTitle } = helpAndSupport;
const { FAQ_CLICK, HOW_TO_GUIDE_CLICK } = MixPanelEventName;
const { howToGuide, frequentlyAsked } = redirectionUrls;

const HelpAndSupport = (): React.JSX.Element => {
  const { helpMenuToggle, setHelpMenuToggle } = helpAndSupportStore;

  const handleFAQClick = () => {
    MixPanel.track(FAQ_CLICK);
    window.open(frequentlyAsked, '_blank');
  };

  const handleHowToGuideClick = () => {
    MixPanel.track(HOW_TO_GUIDE_CLICK);
    window.open(howToGuide, '_blank');
  };

  return (
    <Responsive
      query="max-width"
      props={{
        showMobileView: {
          default: false,
          [ScreenSize._720]: true,
        },
      }}
    >
      {({ showMobileView }) => (
        <Sheet type="overlay" side={showMobileView ? 'bottom' : 'end'} open={helpMenuToggle}>
          <Column spacing="400" heights="fit" width={!showMobileView && '42rem'}>
            <Row alignmentHorizontal="justify">
              <Text type="h400">{title}</Text>
              <Button type="icon" onClick={setHelpMenuToggle} data-testid="closeMenu">
                <Icon tokens={closeSmallTokens} />
              </Button>
            </Row>
            <Divider />
            <Box backgroundColor={colorGray100} type="fill" spacingInset="400">
              <Column spacingInset="300">
                <Row>
                  <Icon className={iconBlueColorStyle} tokens={supportChatTokens} />
                  <Link onClick={handleFAQClick} type="secondary">
                    <Text className={iconBlueColorStyle} type="h300">
                      {FAQTitle}
                    </Text>
                  </Link>
                </Row>
                <Divider />
                <Row>
                  <Icon className={iconBlueColorStyle} tokens={documentTokens} />
                  <Link onClick={handleHowToGuideClick} type="secondary">
                    <Text className={iconBlueColorStyle} type="h300">
                      {HowToGuideTitle}
                    </Text>
                  </Link>
                </Row>
              </Column>
            </Box>
          </Column>
        </Sheet>
      )}
    </Responsive>
  );
};

export default observer(HelpAndSupport);
